import {useContext} from 'external/react'
import {styled, Button, AddIcon} from 'external/material'

import AddExternalGradeForm from './Form'

import {TeacherContext} from 'teacher/context'

const AddButton = styled(Button)(() => ({
    backgroundColor: '#2ca5ec',
    width: 150,
    textTransform: 'none',
    fontSize: '12pt', 
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0069d9',
      borderColor: '#0062cc',
      boxShadow: 'none',
    },
}))

export default function AddExternalGrade () {

  const {translate, updateState} = useContext(TeacherContext)

  function handleClick() {
    updateState({rollbookContextGradingDialogs: {'add-external-grade': {$set: true}}})
  }

  return (
    <>
      <AddButton
        aria-haspopup="true"
        variant="contained"
        color="primary"
        onClick={handleClick}
      startIcon={<AddIcon />}
      >
        {translate('add-grade')}
      </AddButton>
      <AddExternalGradeForm />
    </>
  )
}
